export default {
  meta: {
    title1: "激活页面",
    title2: "登录页面",
    title3: "注册页面",
    title4: "找回密码",
    title5: "消息列表",
    title6: "商品详情",
    title7: "店铺详情",
    title8: "搜索页面",
    title9: "注册店铺",
    title10: "商品列表",
    title11: "精选商品",
    title12: "供应商后台",
    title13: "产品展示页面",
    title14: "产品详情页面",
    title15: "产品编辑页面",
    title16: "联络供应商",
    title17: "管理员登录",
    title18: "用户中心",
    title19: "我的订单",
    title20: "用户设置",
    title21: "我的收藏",
    title22: "店铺关注",
    title23: "浏览记录",
    title24: "收货地址",
    title25: "线下支付",
    title26: "订单页面",
    title27: "收货地址详情",
    title28: "产品页面",
    title29: "产品分类",
    title30: "导入宝贝",
    title31: "订单详情",
    title32: "商品分析",
    title33: "财务报表",
    title34: "认证资料",
    title35: "增加证件",
    title36: "修改手机号",
    title37: "联系客服",
    title38: "服务详情",
    title39: "招商规则",
    title40: "个人用户服务协议",
    title41: "隐私政策",
    title42: "发货及派送",
    title43: "关于我们",
    title44: "问题反馈"
  },
  B2C: {
    back: "返回",
    noMessage: "暂无消息",
    noData: "暂无数据",
    more: "更多精品即将上线!",
    download: "下载 Vancheen App",
    ios: "苹果",
    android: "安卓",
    hotSales: "热销商品",
    registerShop: "注册店铺",
    shopState1: "已认证",
    shopState2: "未通过",
    shopState3: "未认证",
    shopState4: "审核中",
    supplierAuth: "供应商认证",
    login: "立即登录",
    message: "消息中心",
    buy: "立即购买",
    addCart: "添加购物车",
    shopCart: "购物车",
    productsOff: "这些 商品已下架 或 库存不足",
    inventoryState1: "库存不足",
    inventoryState2: "已售罄",
    productOff: "此商品已下架",
    offShelf: "此商品已下架",
    follow1: "已关注",
    follow2: "加关注",
    success: "操作成功",
    skuError: "在商品sku价格集合找不到",
    priceError: "产品没有产品价格集合",
    enterShop: "进入店铺",
    productInfo: "产品信息",
    weight: "重量",
    volume: "体积",
    desc: "产品描述",
    qty: "购买数量",
    inventory: "库存",
    inventoryText: "此产品没有库存",
    inventoryLimit: "购买数量超出库存",
    inputContent: "请输入内容",
    orderInfo: "订单信息",
    receiveAddress: "收货地址",
    name: "姓名",
    phone: "手机号",
    postalCode: "邮编",
    address: "地址",
    noAddress: "暂无收货地址",
    addAddress: "新建地址",
    mode: "配送方式",
    addressError: "已选“收货地址”的国家暂无配送方式，请更换地址",
    selectAddress: "请先选择收货地址",
    fWeight: "首重",
    cWeight: "续重",
    freightTotal: "运费合计",
    confirmOrder: "确认订单信息",
    productPhoto: "商品图片",
    productName: "商品名称",
    productPrice: "价格",
    number: "数量",
    model: "规格",
    shopName: "店铺名称",
    package: "共 {number} 件",
    total: "合计",
    submit: "提交",
    addressVaild1: "请选择收货地址",
    addressVaild2: "请选择配送方式",
    select: "请选择",
    input: "请输入",
    editProduct: "编辑商品",
    addProduct: "添加商品",
    productClass: "产品类别",
    productName: "产品名称",
    productModel: "产品型号",
    productFeatures: "产品特色",
    productDesc: "产品描述",
    customize: "是否可定制",
    yes: "是",
    no: "否",
    isShowcase: "是否设为橱窗产品",
    productState: "产品状态",
    pState1: "上架",
    pState2: "下架",
    productionTime: "生产所需时间(天数)",
    fileList: "文件列表",
    uploadText: "图片上传大少不超过640px * 640px，图片必须上传，至少3张",
    uploadRuleText1: "请上传图片",
    uploadRuleText2: "图片最少上传3张,最多5张",
    uploadSuccess: "上传成功",
    submitSuccess: "提交成功",
    vButton: "马上认证",
    newProduct: "新品上架",
    recommend: "本店推荐",
    loading: "加载中",
    productTotal: "商品总价",
    discount: "优惠",
    brand: "品牌",
    attestation: "认证",
    discountProducts: "优惠商品",
    brandProducts: "品牌商品",
    attestationProducts: "认证商品",
  },
  B2B: {
    header1: "电商平台",
    header2: "登录管理员",
    header3: "退出管理员",
    header4: "登录供应商",
    header5: "供应商后台",
    header6: "用户中心",
    header7: "登录账号",
    header8: "B2B大宗贸易",
    header9: "首页",
    header10: "新版首页",
    header11: "B2C零售商城",
    navbar1: "活动节日",
    navbar2: "产品采购",
    navbar3: "咨询服务",
    navbar4: "关于我们",
    navbar5: "搜寻",
    title1: "中东节假日与商务活动预告表",
    title2: "优选产业库",
    subTitle1: "即将举行的活动",
    classTitle1: "建筑建材",
    classTitle2: "服饰搭配",
    classTitle3: "食品饮品",
    classTitle4: "生产器械",
    classTitle5: "家居电器",
    classTitle6: "汽车用品",
    hidden: "隐藏",
    display: "显示",
    edit: "修改",
    delete: "删除",
    cancelEdit: "取消修改",
    createSlides: "新建轮播",
    editSlides: "修改轮播",
    editIcon: "修改图标",
    createClass: "新建类别",
    editClass: "编辑类别",
    classIcon: "类别图标",
    createAd: "新建广告",
    editAd: "编辑广告",
    title: "中文标题",
    titleEn: "英文标题",
    input: "请输入",
    desc: "中文描述",
    descEn: "英文描述",
    poster: "活动海报",
    link: "跳转链接",
    sort: "排序",
    notice: "平台提示",
    contentAd: "确认删除该广告？",
    cancel: "取消",
    submit: "确定",
    uploadImage: "请上传图片",
    imageLimit: "图片只能上传1张",
    success: "操作成功",
    back: "返回",
    toBasket: "加入询价篮",
    inquiry: "查询",
    keyword: "产品关键字",
    select: "请选择",
    search: "查询",
    reset: "重置",
    noData: "暂无数据",
    orderBy1: "最新上架时间",
    orderBy2: "产品浏览量",
    repeat: "商品已存在",
    addSuccess: "已加入询价篮",
    vButton: "马上认证",
  },
  collapse1: {
    title: "参与会议及展览活动"
  },
  collapse2: {
    title: "常见问题",
    noData: "暂无内容",
    tab1:
      "广泛的产品选择：发现来自世界各地的各行各业的高质量产品，满足您的采购需求。",
    tab2:
      "直接的供应链联系：与制造商和供应商直接对话，减少中间环节，优化采购成本。",
    tab3:
      "定制化解决方案：无论是批量订购还是寻求特定规格的商品，我们都能提供个性化服务以满足您的商务需求。",
    tab4:
      "安全的交易保障：我们的安全支付系统和交易保护政策保障您的采购过程无忧。",
    tab5:
      "全面的客户支持：专业的客户服务团队随时准备帮助解决您在交易过程中遇到的任何问题。",
    tab1Title1: "1. 如何注册vancheen账号？",
    tab1Content1: {
      t1: "不会使用vancheen平台可以点击此处",
      t2: "Vancheen平台操作流程",
      t3: "，点击后将可以查看如何玩转vancheen平台，帮助您更了解平台的操作！"
    },
    tab1Title2: "2. 如何快速搜索心仪的商品？",
    tab1Content2: {
      t1:
        "a.使用商品名称或相对应的厂家，如：想找“面粉”，可以用“面粉”搜索，也可以在厂家频道用“面粉厂”来搜索试试。",
      t2:
        "b.使用筛选条件，我们提供了多种筛选条件，如：“品牌”、“价格”、“城市”等。使用筛选条件，可以帮您进一步提高搜索的精确度"
    },
    tab1Title3: "3. 选好心仪产品后如何支付？",
    tab1Content3: {
      t1: "您可以使用信用卡、网上银行、微信、支付宝支付、公司对账。"
    },
    tab1Title4: "4. 遇到问题如何反馈？",
    tab1Content4: {
      t1:
        "非常抱歉让您有了不好的体验，您可以通过一下几种方式进行反馈您所遇到的问题：",
      t2: "a.点击此处",
      t3: "反馈表格",
      t4: "，进入后可填写表格进行提交反馈问题",
      t5: "b.发送电子邮件来详细说明所遇到的问题。",
      t6: "感谢您的反馈，我们收到后将尽快解决您反馈的问题。"
    }
  },
  collapse3: {
    title1: "Vancheen介绍",
    title2: "平台目标",
    title3: "平台理念",
    content1:
      "发现供需，轻松交易！我们的vancheen平台拥有丰富的客户资源，帮助您快速找到所需的供应商。我们提供便捷的在线支付系统，确保交易安全迅速。高效的交易流程让您节省时间和成本，轻松完成交易。无论您是采购还是销售，我们都能帮助您拓展全球市场，与优质供应商建立合作关系。通过我们的平台，您可以实现全球范围的商机，加速业务增长。立即加入我们的vancheen平台，开启更高效、更便捷的商业交易！",
    content2:
      "简化商业流程、降低交易成本、提高交易效率，并促进合作伙伴之间的业务增长。",
    content3:
      "我们理解每一次交易不仅仅是产品的转移，更是商业价值和信任的建立。加入我们，拓展您的商业边界，让您的企业在全球市场中繁荣发展。"
  },
  basket: {
    title: "询价篮",
    product: "产品",
    supplier: "供应商",
    submit: "提交",
    clear: "清空",
    noData: "暂无数据"
  },
  navBar: {
    search: "搜索"
  },
  topProduct: {
    subTitle: "精选商品",
    empty: "更多精品即将上线!",
    all: "全部"
  },
  commodity: {
    model: "产品型号",
    customize: "是否可定制",
    yes: "是",
    no: "否",
    feature: "特色",
    removeShowcase: "移除橱窗商品",
    setShowcase: "设为橱窗商品",
    desc: "描述",
    contact: "联络供应商",
    lastUpdate: "供应商资料最后更新",
    profile: "供应商简介",
    expand: "展开",
    collapse: "收起"
  },
  business: {
    lastUpdate: "供应商资料最后更新",
    profile: "供应商简介",
    expand: "展开",
    collapse: "收起",
    createCommodity: "添加商品",
    searchInside: "在此店内搜索",
    sort: "排序",
    selection: "精选商品",
    state: "状态",
    tab1: "主页",
    tab2: "产品 / 服务",
    orderBy1: "最新上架时间",
    orderBy2: "产品浏览量",
    state1: "上架",
    state2: "下架",
    yes: "是",
    no: "否",
    delete: "删除成功",

    choiceness: "精选产品/服务",
    viewAll: "浏览全部",
    showcase: "橱窗商品",
    edit: "编辑",
    delete: "删除",
    noProduct: "暂无商品"
  },
  enquiry: {
    contact: "联络供应商",
    notice: "以下信息将传送给供应商",
    email: "电邮地址(填写您的公司电邮地址以获取供应商的迅速回覆)",
    tail: "我们会为您建立一个帐户以联络供应商，请查看电邮并启动帐户。",
    step1: "步骤一",
    step2: "步骤二",
    addressee: "收件人",
    qty: "待采购数量",
    tradeCountry: "贸易目的国",
    currency: "结算货币",
    customize: "是否定制",
    nature: "业务性质",
    emailAddress: "邮箱地址",
    appellation: "称谓",
    name: "名字",
    surname: "姓氏",
    companyName: "公司名称",
    country: "国家 / 地区",
    province: "州 / 省",
    city: "城市",
    content: "查询内容",
    tags: "以下是其他买家提出的常见问题。点击以将它们添加到你的询盘信息中。",
    submit: "提交",
    aOption1: "博士",
    aOption2: "小姐",
    aOption3: "先生",
    aOption4: "太太",
    aOption5: "女士",
    aOption6: "教授",
    yes: "是",
    no: "否",
    success: "提交成功"
  },
  feedback: {
    title: "问题反馈",
    name: "姓名",
    phone: "手机号",
    email: "邮箱",
    content: "反馈内容",
    suggestion: "改进建议",
    file: "附件上传",
    limit: "最多可附件3张",
    submit: "提交",
    thanks: "感谢您的反馈"
  },
  login: {
    userLogin: "C端用户登录",
    supplierLogin: "登录供应商",
    inputEmail: "请输入邮箱",
    inputPhone: "请输入手机号码",
    inputCorrect: "请输入正确的手机号码",
    inputPassword: "请输入密码",
    forgetPassword: "忘记密码?",
    login: "登录",
    register: "注册",
    registerText: "我没有账号，现在就",
    loginSuccess: "登录成功",
    userRegister: "C端用户注册",
    supplierRegister: "供应商注册",
    email: "邮箱",
    vCode: "验证码",
    inputCode: "请输入验证码",
    password: "密码",
    invCode: "邀请码",
    optional: "非必填",
    phoneNumber: "手机号码",
    confirmPassword: "确认密码",
    text1: "点击注册代表同意",
    text2: "《Vancheen个人用户服务协议》",
    and: "和",
    text3: "《Vancheen隐私政策》",
    text4: "《Vancheen服务条款》",
    text5: "我已经注册，现在就",
    inputCorrectEmail: "请输入正确的邮箱",
    inputCorrectPhone: "请输入正确的手机号码",
    passwordRule1: "密码长度至少8位数",
    passwordRule2: "为了你的信息安全请不要过于简单的密码",
    passwordRule3: "为了你的信息安全,密码请设置为大小写字母+数字组合",
    passwordRule4: "两次输入密码不一致!",
    passwordRule5: "请输入确认密码",
    passwordRule6: "请再次输入密码",
    sendCode: "发送验证码",
    registerSuccess: "恭喜您，注册成功",
    retrievePassword: "密码找回",
    retrieve1: "C端用户找回密码",
    retrieve2: "供应商找回密码",
    step1: "找回方式",
    step2: "验证身份",
    step3: "设置新密码",
    step4: "完成",
    cEmail: "验证邮箱",
    cPhone: "验证手机",
    inputNewPassword: "请输入新的密码",
    backLogin: "返回登录",
    confirm: "确定",
    nextStep: "下一步",
    adminLogin: "管理员登录",
    inputUsername: "请输入登录名"
  },
  container: {
    notice: "公告列表",
    top: "置顶",
    noticeText: "共 {number} 条公告",
    previous: "上一页",
    next: "下一页",
    noNotice: "暂无公告",
    noticeDetail: "公告详情",
    switch1: "切换 B2B 企业简介页面",
    switch2: "切换 B2B2C 发布商品",
    backHome: "返回主页",
    settings: "用户设置",
    logout: "退出登录",
    serviceEmail: "客服邮箱",
    contactService: "联系客服",
    serviceText: "选择您所需要的服务",
    select: "请选择",
    inputContent: "请输入内容",
    contactWay: "您的联系方式",
    inputEmail: "请提供邮箱地址",
    submit: "提交",
    bandTitle: "平台提示",
    bandContent: "您的账户已违规封禁，请联系vancheen客服",
    close: "关闭",
    sOption1: "投诉与建议",
    sOption2: "退款申请",
    sOption3: "其他",
    rOption1: "审核不通过",
    rOption2: "审核中",
    rOption3: "待审核",
    rOption4: "请上传审核资料",
    rOption5: "审核失败",
    infoError: "您的信息还在审核中",
    submitError: "请填写所有后提交",
    tips: "提示"
  },
  public: {
    upload: "上传公司Logo",
    display1: "企业名称 英文展示",
    display2: "企业名称 图片展示",
    input: "请输入",
    select: "请选择",
    companyNameCn: "公司名字 ( 中文 ) ",
    companyNameEn: "公司名字 ( 英文 ) ",
    characterColorCode: "企业名字字色",
    backgroundColorCode: "企业名字底色",
    companyNameImage: "图片展示",
    companyProfileCn: "企业中文简介",
    companyProfileEn: "企业英文简介",
    classValue: "店铺展示类别",
    orderBy: "排序",
    submit: "提交",
    product: "产品",
    productShow: "产品展示",
    editPage: "进入编辑页",
    others: "其他",
    feedback: "问题反馈",
    toFeedback: "去反馈",
    explain: "说明",
    state1: "您提交的认证资料审核不通过",
    state2: "立即重新认证",
    orderBy1: "最新上架时间",
    orderBy2: "产品浏览量",
    orderBy3: "产品成交量",
    rule1: "请上公司Logo",
    rule2: "请输入公司名字 ( 中文 ) ",
    rule3: "请输入公司名字 ( 英文 ) ",
    infoAlert: "请先完善企业信息",
    alert: "您的信息还在审核中",
    uploadSuccess: "上传成功",
    tips: "提示",
    saveSuccess: "保存成功",
  },
  default: {
    title1: "待付款",
    title2: "待发货",
    title3: "物流异常",
    title4: "违规提醒",
    title5: "整体数据",
    title6: "访客数",
    title7: "买家数",
    title8: "支付金额",
    compare: "较日前",
    person: "人",
    dollar: "美元",
    subTitle1: "宝贝管理",
    menu1: "发布宝贝",
    menu2: "出售中的宝贝",
    menu3: "仓库中的宝贝",
    subTitle2: "物流管理",
    menu4: "待付款",
    menu5: "待发货",
    menu6: "已发货",
    subTitle3: "数据中心",
    menu7: "总体数据",
    menu8: "商品分析",
    subTitle4: "财务中心",
    menu9: "财务报表"
  },
  order: {
    tab1: "全部订单",
    tab2: "等待买家付款",
    tab3: "等待发货",
    tab4: "已发货",
    tab5: "成功的订单",
    tab6: "关闭的订单",
    batch: "批量更新快递单号",
    totalOrder: "共 {number} 个订单",
    previous: "上一页",
    next: "下一页",
    col1: "宝贝",
    col2: "单价",
    col3: "数量",
    col4: "操作",
    col5: "交易状态",
    col6: "实收款",
    orderNumber: "订单号",
    createTime: "创建时间",
    allPrice: "总金额",
    specification: "规格",
    inputExpress: "填写快递单号",
    inputExpressNumber: "请输入快递单号",
    expresNumber: "快递单号",
    noToPay: "不收到付邮包",
    closeOrder: "关闭订单",
    detail: "详情",
    viewLogistics: "查看物流",
    printTag: "打印标签",
    noData: "暂无数据",
    cancel: "取消",
    confirm: "确定",
    tips: "提示",
    reason: "请选择关闭订单原因"
  },
  analysis: {
    title: "访客数TOP50",
    tab1: "近三天",
    tab2: "近七天",
    tab3: "近三十天",
    tab4: "全部",
    col1: "宝贝",
    col2: "发布时间",
    col3: "浏览量",
    col4: "访客数",
    col5: "支付金额",
    col6: "支付买家数",
    col7: "支付转化率",
    col8: "被选取数"
  },
  finance: {
    balance: "账户总额（美元）",
    rate: "今日汇率",
    time: "时间",
    filter: "筛选",
    select: "请选择",
    search: "查询",
    startDate: "开始日期",
    to: "至",
    endDate: "结束日期",
    text1: "期间结算收入支出总额",
    income: "收入",
    payout: "支出",
    text2: "期间结算收入支出明细",
    text3: "结算收入支出明细",
    text4: "结算收入支出总额",
    text5: "请先完善身份证号码",
    text6: "申请成功，请与客服联系",
    excel: "导出Excel表格",
    entryTime: "入账时间",
    flow: "流水号",
    financialType: "财务类型",
    moneyAmount: "收支金额",
    oneWeek: "最近一周",
    oneMonth: "最近一个月",
    threeMonth: "最近三个月",
    withdraw: "提现",
    all: "全部",
    tips: "提示",
    dialogSubTitle: "提现总金额",
    dText1: "请选择提现帐号",
    account1: "企业帐号",
    account2: "法人/个人帐号",
    account3: "完善身份证号码",
    dText2: "请选择需要提现的订单",
    col1: "订单号",
    col2: "金额",
    col3: "时间",
    cancel: "取消",
    confirm: "确定",
    withdrawRecord: "提现记录",
    incomeText: "{startTime} 至 {endTime} 收入支出明细",
  },
  products: {
    tab1: "出售中的宝贝",
    tab2: "仓库中的宝贝",
    btn1: "设置上架",
    btn2: "设置下架",
    btn3: "批量删除",
    btn4: "添加商品",
    count: "共 {number} 件商品",
    col1: "商品名称",
    col2: "价格",
    col3: "销量",
    col4: "创建时间",
    onSale: "出售中",
    warehouse: "仓库",
    col5: "备注",
    col6: "操作",
    col7: "库存总额",
    inventoryState1: "库存不足",
    inventoryState2: "已售罄",
    now: "立即",
    state1: "上架",
    state2: "下架",
    edit: "编辑商品",
    delete: "删除",
    deleteText: "请选中需要删除的宝贝",
    deleteSuccess: "删除成功",
    tips: "提示",
    selectText: "请选中需要 {string} 的宝贝",
    success: "成功",
    confirm: "确定",
    isCouponProduct: "优惠",
    isBrandProduct: "品牌",
    isAttestationProduct: "认证",
    yes: "是",
    no: "否",
  },
  productClasses: {
    breadcrumb1: "宝贝管理",
    breadcrumb2: "发布宝贝",
    history: "历史记录",
    selectText: "您当前的选择是",
    submit: "提交",
    tips: "平台提示",
    text1: "仅当商品在Vancheen平台成交时，Vancheen将按商品成交金额的10%作为平台使用费。",
    text2: "例如：您所发布的商品在Vancheen平台以100美元的价格售出，平台将收取100×10%=10美元的平台使用费，商家待结算金额为90美元，本费用已包含境外第三方收单平台之手续费。",
    text3: "如收费规则变化，Vancheen将于平台公告及时更新。商家提现请参照商家提现规则条款。",
    confirm: "确认",
    unselect: "未选择",
    selectClass: "请选择分类",
  },
  productEdit: {
    breadcrumb1: "宝贝管理",
    breadcrumb2: "发布宝贝",
    breadcrumb3: "基本信息",
    breadcrumbTips: "温馨建议：请以英文输入为首选",
    unselect: "未选择",
    editCategory: "修改类目",
    productName: "商品名",
    productPlaceHolder: "请输入商品名(必须是英文)",
    productNote: "商品名最多64个字符",
    keyword: "关键词",
    createKeyword: "添加关键词",
    keywordNote: "搜索商品时会去匹配商品名和关键词，每件商品最多设置10个关键词。",
    weight: "重量",
    weightPlaceholder: "带包装称重",
    kilogram: "千克",
    kilogramNote: "最多四位小数，涉及运费请精确填写",
    volume: "体积",
    long: "长",
    width: "宽",
    height: "高",
    packageVolume: "包装体积",
    precision: "最多三位小数，涉及运费请精确填写",
    descriptions: "产品描述",
    descriptionsNote: "请输入产品描述(必须是英文)",
    uploadPhoto: "上传图片",
    uploadPhotoNote: "图片上传大少不超过640px * 640px，图片必须上传，至少3张",
    uploadVideo: "上传视频",
    uploadVideoNote: "视频上传大少不超过10MB",
    nature: "商品性质",
    attribute: "商品属性",
    liquid: "液体",
    powder: "粉末",
    paste: "膏状",
    charged: "带电 ( 含电池 )",
    magnetic: "带磁性",
    dontBelong: "均不属于",
    specTitle: "库存/规范",
    spec: "商品规格",
    inputSpec: "请选择或输入规格",
    specSettings: "规格设置",
    oPrice: "原价",
    cPrice: "现价",
    inventory: "库存",
    selectAll: "全选",
    cancel: "取消",
    setPrice: "批量设置价格",
    setInventory: "批量设置库存",
    onShelfSettings: "上架设置",
    deposit: "存入仓库",
    onShelf: "立即上架 ( 可24小时内发货 )",
    remark: "备注",
    inputRemark: "请输入备注",
    submit: "提交",
    productCategory: "商品类目",
    explain: "说明",
    tips: "平台提示",
    text1: "仅当商品在Vancheen平台成交时，Vancheen将按商品成交金额的10%作为平台使用费。",
    text2: "例如：您所发布的商品在Vancheen平台以100美元的价格售出，平台将收取100×10%=10美元的平台使用费，商家待结算金额为90美元，本费用已包含境外第三方收单平台之手续费。",
    text3: "如收费规则变化，Vancheen将于平台公告及时更新。商家提现请参照商家提现规则条款。",
    confirm: "确定",
    rule1: "产品描述请填写英文",
    rule2: "请先选择类目",
    rule3: "请输入商品名",
    rule4: "商品名最多64个字符",
    rule5: "副标题最多64个字符",
    rule6: "每件商品最多设置10个关键词",
    rule7: "请输入基础销量",
    rule8: "请输入正确的基础销量",
    rule9: "请输入重量",
    rule10: "请输入正确的重量",
    rule11: "请输入体积",
    rule12: "请输入正确的体积",
    rule13: "请上传图片",
    rule14: "图片最少上传3张,最多10张",
    rule15: "商品规格原价最多输入两位小数",
    rule16: "商品规格的各个原价要大于等于0.1",
    rule17: "请填写商品规格的各个原价",
    rule18: "商品规格现价最多输入两位小数",
    rule19: "商品规格的各个现价要大于等于0.1",
    rule20: "请填写商品规格的各个现价",
    rule21: "图片最少上传1张,最多18张",
    addText: "{firstCount}件内${firstPrict}，每增加{addCount}件，加${addPrice}",
    error1: "已存在的关键词",
    error2: "已存在的",
    error3: "请先选择规格类型并填写规格",
    error4: "添加内容过长（内容字符长度为1-40个字符）",
    addFreightTitle: "新增运费模板",
    editFreightTitle: "编辑运费模板",
    messageSpec: "请选择要设置的规格",
    promptPrice: "请输入价格(美元)",
    promptInventory: "请输入库存",
    formatPrice: "价钱格式不正确",
    formatInventory: "库存格式不正确",
    submitSuccess: "提交成功",
    couponTitle: "优惠活动",
    couponText: "是否参加优惠活动",
    brandTitle: "品牌产品",
    brandText: "是否品牌产品",
    brandLogo: "品牌logo",
    brandAuth: "品牌授权书",
    trademark: "商标注册证",
    attTitle: "商品认证",
    attText: "是否认证商品",
    attType: "请选择认证类型",
    upload: "请上传",
  },
  certification: {
    title1: "完善信息",
    subTitle1: "实名认证",
    text1: "申请人确认本次实名认证所提供之文件的真实性与有效性，在完成申请认证后承诺遵守Vancheen账户店铺的用户管理规定。",
    text2: "申请人确定完成实名认证之店铺，未经Vancheen同意，不得以任何方式转让、出售或借于第3方，由此而产生的一切责任由申请人承担；如有违反，Vancheen有权无条件关闭该店铺账户。",
    menu1: "企业账户实名认证",
    menu2: "个体户账户实名认证",
    vButton: "去认证",
    authFail: "审核不通过原因",
    title2: "资料填写",
    subTitle2: "上传营业执照照片",
    text3: "照片上所有信息需清晰可见，内容真实有效，不得做任何修改",
    text4: "照片支持：jpg, jpeg, png, pdf格式，大小不超过10m",
    sample: "示例图片",
    upload: "上传",
    label1: "统一社会信用代码/注册号",
    label2: "营业执照上的名称",
    label3: "经营期限至",
    selectDate: "请选择日期",
    longTime: "长期",
    area: "所在地区",
    detailAddress: "详细地址",
    detailAddressText: "请输入您的详细地址，以便在有需要时给您寄送书面文件",
    lPerson: "法人名字",
    lPersonID: "法人身份证",
    IdNumber: "身份证号码",
    sampleFront: "正面示例",
    sampleBack: "背面示例",
    note: "店铺持有人应依照当地税务法规依法纳税，账户信息认证成功后将无法修改。",
    bankTitle: "企业银行信息",
    bankName: "开户行",
    bankAccountName: "账户名称",
    bankNote: "导入上列企业营业执照名称，不得修改",
    bankCardNumber: "收款账号",
    bankAddress: "银行地址",
    legalTitle: "法人银行信息",
    rule1: "请上传营业执照",
    rule2: "请输入统一社会信用代码/注册号",
    rule3: "请输入营业执照上的名称",
    rule4: "请选择经营期限",
    rule5: "请选择所在地区",
    rule6: "请输入您的详细地址",
    rule7: "请输入法人名字",
    rule8: "请上传法人身份证正面",
    rule9: "请上传法人身份证反面",
    rule10: "请输入身份证号码",
    rule11: "请输入企业银行开户行",
    rule12: "请输入企业银行账户名称",
    rule13: "请输入企业银行收款账号",
    rule14: "请输入企业银行详细地址",
    rule15: "请输入法人银行开户行",
    rule16: "请输入法人银行账户名称",
    rule17: "请输入法人银行收款账号",
    rule18: "请输入法人银行详细地址",
    submitSuccess: "提交成功",
    submitFail: "提交失败",
    type1: "企业",
    type2: "个体户"
  },
  productInfo: {
    orderDetail: "订单详情",
    currentState: "当前订单状态",
    closeReason: "订单关闭原因",
    tab1: "订单信息",
    tab2: "物流信息",
    buyInfo: "买家信息",
    receivingName: "收货人",
    phoneNumber: "联系电话",
    receivingAddress: "收货地址",
    orderNumber: "订单编号",
    payNumber: "交易号",
    createTime: "创建时间",
    payTime: "付款时间",
    noLogistics: "暂无物流状态",
    col1: "宝贝",
    col2: "规格",
    col3: "状态",
    col4: "数量",
    col5: "单价",
    col6: "优惠",
    col7: "实收款",
    category: "分类",
    noState: "暂无状态",
    express: "快递"
  },
  //C端
  cDefault: {
    title1: "待付款",
    title2: "待发货",
    title3: "待收货",
    subTitle1: "用户管理",
    menu1: "我的收藏",
    menu2: "店铺关注",
    menu3: "注册店铺",
    menu4: "浏览记录",
    menu5: "收货地址",
    subTitle2: "我的订单",
    menu6: "待付款",
    menu7: "待发货",
    menu8: "待收货",
    menu9: "已完成",
    subTitle3: "其他",
    menu10: "服务协议",
    menu11: "隐私政策",
    menu12: "平台规则",
    menu13: "关于我们",
    menu14: "优惠券",
  },
  couponInterpret: {
    state1: "待使用",
    state2: "已使用",
    state3: "已失效",
    goUse: "去使用",
    endDate: "到期时间",
    noCondition: "无门槛",
    condition: "满 {value} 使用",
    maxCount: "限领 {value} 张",
    couponCount: "{value} 元优惠券",
    alertTitle: "您已收到以下优惠券",
    col1: "优惠券",
    col2: "使用条件",
    col3: "到期时间",
    noCoupon: "暂无优惠券",
    canuseTitle: "可使用的优惠券",
    notuseTitle: "不可使用的优惠券",
    reason: "本单不可用原因: 不满足使用条件"
  },
  cOrder: {
    tab1: "全部订单",
    tab2: "待付款",
    tab3: "待发货",
    tab4: "待收货",
    tab5: "已完成",
    totalOrder: "共 {number} 个订单",
    toDetail: "商品详情",
    col1: "商品信息",
    col2: "商品名称",
    col3: "订单号",
    col4: "价格",
    col5: "状态",
    col6: "创建时间",
    col7: "操作",
    col8: "规格",
    col9: "数量",
    col10: "物流",
    col11: "总价",
    freight: "含运费",
    pay: "立即支付",
    cancelOrder: "取消订单",
    confirmOrder: "确认收货",
    viewLogistics: "查看物流",
    payVoucher: "支付凭证",
    payMethod: "支付方式",
    noPayment: "暂无支付方式",
    orderNumber: "订单号",
    logisticsState: "物流状态",
    postNumber: "物流单号",
    option1: "信用卡在线支付",
    option2: "线下支付",
    errorText: "此订单不是线下支付",
    payDetail: "查看 / 支付",
    countDown: "逾期订单将自动取消 , 剩余时间",
    orderDetail: "订单详情",
    closeReason: "订单关闭原因",
    currentState: "当前订单状态",
    orderTime: "下单时间",
    payTime: "付款时间",
    freightText: "运费",
    totalText: "总计",
    textButton: "当前线下支付 “{text}” ，点击查看",
    shopName: "店铺"
  },
  goodsAttention: {
    col1: "商品图片",
    col2: "商品名称",
    col3: "价格",
    col4: "状态",
    col5: "操作",
    state1: "已下架",
    state2: "上架中",
    viewProduct: "查看商品",
    cancelFavorite: "取消收藏"
  },
  shopAttention: {
    col1: "店铺图片",
    col2: "店铺名称",
    col3: "操作",
    viewStore: "查看店铺",
    cancelFollow: "取消关注"
  },
  footmark: {
    col1: "商品图片",
    col2: "商品名称",
    col3: "价格",
    col4: "浏览日期",
    col5: "操作",
    viewProduct: "查看商品",
  },
  shipping: {
    create: "新增收货地址",
    name: "姓名",
    phoneNumber: "手机号",
    postalCode: "邮编",
    address: "地址",
    operate: "操作",
    edit: "编辑",
    delete: "删除",
    editAddress: "编辑收货地址",
    receivingName: "收件人姓名",
    country: "国家",
    city: "城市",
    addressDetail: "详情地址",
    isDefault: "设置为默认地址",
    submit: "提交",
    yes: "是",
    no: "否",
    default: "默认地址"
  },
  userManage: {
    title: "用户设置",
    subTitle1: "更改头像",
    subTitle2: "用户名",
    subTitle3: "修改昵称",
    changeAvatar: "更换头像",
    nickname: "昵称",
    nickname1: "原昵称",
    nickname2: "新昵称",
    updateName: "更新昵称",
    uploadLimit: "上传头像图片大小不能超过 1MB!"
  },
  contactService: {
    title: "问题列表",
    createProblem: "添加问题",
    col1: "问题标题",
    col2: "问题类型",
    col3: "提交时间",
    col4: "状态",
    col5: "操作",
    view: "查看",
    tips: "提示",
    serviceContent: "选择您所需要的服务",
    inputTitle: "请输入问题标题",
    inputContent: "请输入内容",
    contact: "您的联系方式",
    inputEmail: "请提供邮箱地址/手机号",
    submit: "提交",
    option1: "投诉与建议",
    option2: "退款申请",
    option3: "其他",
    inputAll: "请填写所有后提交",

    detailTitle: "问题详情",
    row1: "标题",
    row2: "内容",
    row3: "联系方式",
    row4: "创建时间",
    record: "沟通记录",
    col6: "日期",
    col7: "回复人",
    col8: "回复内容",
    noRecord: "暂无记录",
    addTo: "追加提问",
    dialogContent: "请输入您的追加提问",
  },
  authentication: {
    authFail: "审核不通过原因",
    info: "资料填写",
    upload: "上传",
    text1: "驾驶证或护照图片（正反面）",
    text2: "照片上所有信息需清晰可见，内容真实有效，不得做任何修改；",
    text3: "照片支持：jpg, jpeg, png, pdf格式，大小不超过10m",
    title: "店铺信息",
    passPort: "驾照号/护照号",
    name: "名字",
    bankName: "银行名称",
    bankNumber: "银行账号",
    bankAddress: "银行地址",
    postAddress: "邮寄地址",
    shopName: "店铺名称",
    submit: "提交",
    rule1: "请上传驾驶证或护照图片",
  },
  payment: {
    authFail: "审核不通过原因",
    step1: "准备上传",
    step2: "审核中",
    step3: "审核不通过",
    step4: "审核通过",
    transfer1: "请转账至下方银行账号，并提供银行转账凭证截图",
    transfer2: "填写支付账户信息",
    accountName: "账户名称",
    accountNumber: "账户号码",
    bankAddress: "银行地址",
    postAddress: "邮寄地址",
    bankName: "银行名称",
    uploadFile: "上传文件",
    uploadText: "请上传支付凭证的截图，保证内容清晰可见",
    name: "名字",
    bankNumber: "银行卡号",
    submit: "提交",
    reSubmit: "重新提交",
  }
};
